import { atom } from "recoil";
import { lineOfBusinessInfo } from "../types";

export const addStateLineOfBusiness = atom({
  key: "addStateLineOfBusiness ",
  default: false,
});

export const editStateLineOfBusiness = atom({
  key: "editStateLineOfBusiness",
  default: false,
});

export const selectedRowsStateLineOfBusiness = atom<lineOfBusinessInfo[]>({
  key: "selectedRowsStateLineOfBusiness",
  default: [],
});

export const filterText = atom({
  key: "setFilterTextLineOfBusiness",
  default: "",
});

export const selectedRowsToDelete = atom< undefined | [] >({
  key: "selectedRowsToDelete",
  default: [],
});

export const rowEditIdStateLineOfBusiness = atom({
  key: "rowEditIdLicenseType",
  default: null,
});

export const rowForEditLineOfBusiness = atom<lineOfBusinessInfo | undefined>({
    key: "rowForEditAgencyMapping",
    default: undefined,
  });

export const lobSaving = atom({
    key: "agencyMappingsSaving",
    default: false,
  });

export const disableButtonStateLineOfBusiness = atom({
    key: "disableButtonLicenseType",
    default: false,
  });

export const lineOfBusinessFetching = atom({
    key: "lineOfBusinessFetching",
    default: false,
  });

  